<template>
  <div>
    <va-card class="overflow-auto">
      <vue-element-loading :active="visible" :is-full-screen="true" />
      <div class="row">
        <div class="flex md6 sm6 xs12">
          <h4 style="font-size:24px!important" class="card-title mx-2">Query Reply</h4>
        </div>
      </div>
       <b-form @submit="onSubmit" @reset="onReset" >
             <b-row class="mt-2">
    <b-col sm="10">
      <b-form-textarea
      v-model="replyMsg"
         id="textarea-auto-height"
           rows="3"
        max-rows="10"
        style="200px!important"
        no-auto-shrink
        placeholder="Reply..."
      ></b-form-textarea>
    </b-col>
    <b-col sm="1">
    </b-col>
  </b-row>
  <div class="flex md10 sm6 xs12 pt-4" align="right">
    <b-button type="submit" variant="success">Submit</b-button>
    </div>
           </b-form>
      </va-card>
  </div>
</template>

<script>
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
export default {
  components: {
    VueElementLoading,
  },
  props: ['id'],
  data () {
    return {
      visible: false,
      data: [],
      replyMsg: '',
    }
  },
  methods: {

    onSubmit (evt) {
      this.visible = true
      var data = {}
      data['id'] = this.id
      data['replyMsg'] = this.replyMsg
      console.log(this.data)
      evt.preventDefault()
      axios({
        method: 'POST',
        url: '/contactadmin/reply',
        headers: {
          token: localStorage.getItem('token'),
        },
        data: data,
      })
        .then(response => {
          this.msg = response.data.msg
          this.visible = 'false'
          this.$dlg.alert(
            this.msg,
            () => {
              this.$router.push('/listqueries')
            },
            { messageType: 'success' }
          )
        })
        .catch(e => {
          console.log(e)
        })
    },
  },
}
</script>
<style scoped>
/* .modal-footer {
  display: none !important;
} */
</style>
